import {
  validateIfExist,
  validateRegex,
  validateLength,
  validatePhoneNumber,
} from './validators';

const formSchema = [
  {
    id: 'firstName',
    name: 'firstName',
    label: 'firstNameLabel',
    type: 'text',
    placeholder: 'firstNamePlaceholder',
    isRequired: true,
    value: '',
    ariaLabel: 'firstNameAriaLabel',
    validators: [
      {
        isValid: validateIfExist,
        message: 'firstNameErrorMessage',
      },
      {
        isValid: (val) => (val ? validateLength(val, 1 , 'min') : true),
        message: 'minFieldLength',
      },
      {
        isValid: (val) => validateLength(val, 40, 'max'),
        message: 'maxFieldLength',
      },
    ],
  },
  {
    id: 'lastName',
    name: 'lastName',
    label: 'lastNameLabel',
    type: 'text',
    placeholder: 'lastNamePlaceholder',
    isRequired: true,
    ariaLabel: 'lastNameAriaLabel',
    value: '',
    validators: [
      {
        isValid: validateIfExist,
        message: 'lastNameEmptyErrorMessage',
      },
      {
        isValid: (val) => validateLength(val, 80, 'max'),
        message: 'maxFieldLength',
      },
    ],
  },
  {
    id: 'email',
    name: 'email',
    label: 'emailLabel',
    type: 'text',
    placeholder: 'emailPlaceholder',
    isRequired: true,
    ariaLabel: 'emailAriaLabel',
    value: '',
    validators: [
      {
        isValid: validateRegex,
        message: 'emailFormatErrorMessage',
      },
      {
        isValid: validateIfExist,
        message: 'emailEmptyErrorMessage',
      },
      {
        isValid: (val) => validateLength(val, 80, 'max'),
        message: 'maxFieldLength',
      },
    ],
  },
  {
    id: 'phoneNumber',
    name: 'phone',
    label: 'phoneLabel',
    type: 'phone',
    placeholder: 'phonePlaceholder',
    country: 'gb',
    specialLabel: 'phoneArialabel',
    value: '',
    validators: [
      {
        isValid: validatePhoneNumber,
        message: 'phoneErrorMessage',
      },
    ],
  },
  {
    id: 'caseType',
    name: 'caseType',
    label: 'caseTypeLabel',
    isRequired: true,
    type: 'select',
    options: [
      { value: 'Complaint', name: 'caseTypeComplaintLabel' },
      { value: 'Enquiry', name: 'caseTypeEnquiryLabel' },
      { value: 'Feedback', name: 'caseTypeFeedbackLabel' },
    ],
    ariaLabel: 'caseTypeArialabel',
    value: '',
    validators: [
      {
        isValid: validateIfExist,
        message: 'caseTypeEmptyErrorMessage',
      },
    ],
  },
  {
    id: 'description',
    name: 'description',
    label: 'descriptionLabel',
    role: 'textbox',
    placeholder: 'descriptionPlaceholder',
    type: 'textarea',
    ariaLabel: 'descriptionAriaLabel',
    value: '',
    validators: [
      {
        isValid: validateIfExist,
        message: 'descriptionEmptyErrorMessage',
      },
      {
        isValid: (val) => validateLength(val, 3200, 'max'),
        message: 'maxFieldLength',
      },
    ],
  },
];

export default formSchema;
